export function getSectionSummary(data, section) {
	const baseline = data.survey.baseline.data.filter(d => d.id === section);
	const exit = data.survey.exit.data.filter(d => d.id === section);

	return {
		baseline,
		exit,
	};
}
